import {
  createStore,
  useStore,
  createLogger,
  Store as VuexStore,
  CommitOptions,
  DispatchOptions
} from "vuex";
import { State, defaultState } from "./state";
import { GetterValues, getters } from "./getters";
import { Mutations, mutations } from "./mutations";
import { Actions, actions } from "./actions";

// https://dev.to/3vilarthas/vuex-typescript-m4j
export type Store = Omit<VuexStore<State>, "getters" | "commit"> & {
  commit<K extends keyof Mutations, P extends Parameters<Mutations[K]>[1]>(
    key: K,
    payload: P,
    options?: CommitOptions
  ): ReturnType<Mutations[K]>;
} & {
  dispatch<K extends keyof Actions>(
    key: K,
    payload: Parameters<Actions[K]>[1],
    options?: DispatchOptions
  ): ReturnType<Actions[K]>;
} & {
  getters: GetterValues;
};

// Too much on global state, I think these should be namespaced modules
export const store: Store = createStore({
  state: defaultState(),
  getters,
  mutations,
  actions,
  plugins: [createLogger()]
});

export const useTypedStore = (): Store => {
  return useStore();
};

// DEBUG:
// eslint-disable-next-line
(window as any).store = store;

export default store;
